import axios from "axios";
import { useAuth } from "@clerk/clerk-react";
import { useMemo } from "react";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Public, unauthenticated client
export const publicApi = axios.create({ baseURL: API });

// Hook returning an axios instance that injects the Clerk session token
export function useApi() {
  const { getToken } = useAuth();
  return useMemo(() => {
    const instance = axios.create({ baseURL: API });
    instance.interceptors.request.use(async (config) => {
      const token = await getToken();
      if (token) config.headers.Authorization = `Bearer ${token}`;
      return config;
    });
    return instance;
  }, [getToken]);
}

export const CATEGORY_LABELS = {
  table: "La Table",
  salon: "Le Salon",
  atelier: "L'Atelier",
  concert: "Concert",
  theatre: "Théâtre",
  festival: "Festival",
  talk: "Rencontre",
  show: "Spectacle",
};

export const CATEGORY_ORDER = ["table", "salon", "concert", "theatre", "show", "festival", "atelier", "talk"];

export function priceLabel(price) {
  return price > 0 ? formatEuro(price) : "Free";
}

export function formatEuro(amount) {
  return new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(amount);
}

export function formatDate(iso) {
  try {
    return new Date(iso).toLocaleDateString("en-GB", {
      weekday: "short", day: "numeric", month: "long",
    });
  } catch { return iso; }
}

export function formatTime(iso) {
  try {
    return new Date(iso).toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" });
  } catch { return ""; }
}
